import { gql } from '@apollo/client';
import type { ScanPromptInfo } from '../../scanResult';

/** 合包扫描专用查询：字段打平，含 promptInfo 错误提示 */
export const GET_BAG_MERGE_SCAN_INFO_BY_NUMBER = gql`
  query GetBagMergeScanInfoByNumber($bagNumber: String!) {
    getBagMergeScanInfoByNumber(bagNumber: $bagNumber) {
      id
      bagNumber
      businessType
      sortingCode
      sortingRule
      sortingRuleFirst
      parcelCount
      mergeableParcelCount
      ttBizType
      preSortingCode
      status
      warehouseId
      printType
      success
      message
      promptInfo {
        messageKey
        popupType
        title
        content
      }
    }
  }
`;

export interface BagMergeScanInfoType {
  success: boolean;
  message?: string | null;
  id?: string | null;
  bagNumber?: string | null;
  businessType?: number | null;
  sortingCode?: string | null;
  /** 分拣规则：from-nextStop-尾程商缩写 */
  sortingRule?: string | null;
  /** 原始第一分拣规则（bag.sorting_rule_first）；空=预分拣上线前的存量包牌，一致性校验按存量口径 */
  sortingRuleFirst?: string | null;
  /** 包裹数量（BOUND 且未删除） */
  parcelCount?: number | null;
  /** 可合包包裹数（BOUND 且非 is_finished） */
  mergeableParcelCount?: number | null;
  /** TT 分拣业务类型（FBT/CBT/UNLIMITED）；空=存量包牌，按不限处理 */
  ttBizType?: string | null;
  /** 预分拣码（第二分拣规则，含尾程商前缀如 UNI_SEA01）；空=无预分拣 */
  preSortingCode?: string | null;
  status?: number | null;
  /** 创建站点ID */
  warehouseId?: number | null;
  /** 打印模板类型(1-SwiftX、2-TT) */
  printType?: number | null;
  promptInfo?: ScanPromptInfo | null;
}

export interface GetBagMergeScanInfoByNumberResponse {
  getBagMergeScanInfoByNumber: BagMergeScanInfoType;
}
